module.exports = __webpack_public_path__ + "static/media/expand-arrow.766f317c.svg";